import React, { useState, Fragment } from "react";
import { li, UL } from "../../../AbstractElements";
import { Filter, Sliders } from "react-feather";
import { useForm, useController } from "react-hook-form";
import { FilterButton, LevelMenu } from "../../../Constant";
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import FilterForm from "./FilterForm";

const FilterTable = (props) => {
  const [levelMenu, setLevelMenu] = useState(() => false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => {
    setDropdownOpen((prevState) => !prevState);
    setLevelMenu(!levelMenu);
  };

  // const onFilterBlured = ()=>{
  //   setLevelMenu(false);
  // };

  // console.log("tripFilterColumns",props.options)

  return (
    <Fragment>
      <Dropdown
        isOpen={dropdownOpen}
        toggle={toggle}
        className="button-level-menu outside"
      >
        <DropdownToggle
          tag="span"
          className="d-flex align-items-center justify-content-center"
          style={{
            width: "2.78vw",
            height: "2.92vw",
            backgroundColor: "white",
            border: "1px solid rgba(217, 217, 217, 1)",
            borderRadius: "10px",
            cursor: "pointer",
          }}
        >
          <Sliders style={{ width: "1.5vw", height: "1.5vw", color: "#555" }} />
        </DropdownToggle>
        <DropdownMenu
          tag={"ul"}
          className="header-level-menu menu-to-be-close"
          style={{ zIndex: 1300 }}
        >
          <FilterForm
            toggle={toggle}
            options={props.options}
            filterData={props.filterData}
            setFilterData={props.setFilterData}
            setSearchData={props.setSearchData}
            setFilterType={props.setFilterType}
            statusData={props.statusData}
            bookingViaTypeData={props.bookingViaTypeData}
            pickupTypeData={props.pickupTypeData}
            setQFName={props.setQFName}
            setQFValue={props.setQFValue}
            carTypeData={props.carTypeData}
            aggregatorData={props.aggregatorData}
            clientTypeData={props.clientTypeData}
            rideTypeData={props.rideTypeData}
            bookingSourceData={props.bookingSourceData}
            terminalData={props.terminalData}
          />
        </DropdownMenu>
      </Dropdown>
      {/* <div onBlur={()=>onFilterClick(levelMenu)}>
   
      <button type="submit" className="button-level-menu outside" 
      // onBlur={()=>{onFilterBlured()}}
      >
        <a
          className={levelMenu ? "nav-link active" : "nav-link"}
          href="#javascript"
          onClick={() => onFilterClick(levelMenu)}
          
        >
          <Filter />
          <span>{FilterButton}</span>
        </a>
        {levelMenu ? (
          <FilterForm
            LevelMenu={LevelMenu}
            options={props.options}
            filterData={props.filterData}
            setFilterData={props.setFilterData}
            onFilterClick={onFilterClick}
            setSearchData={props.setSearchData}
            setFilterType={props.setFilterType}
          />
        ) : (
          ""
        )}
      </button>
      </div> */}
    </Fragment>
  );
};

export default FilterTable;
